<template>
	<b-modal ref="modal" class="modal-primary" @ok="onOkModal" @cancel="onCancelModal" :title="modalTitle" :ok-title="modalOkTitle" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<b-form ref="form" novalidate>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg" @dismissed="clear_error_msg"></app-mbox>
			<b-row >
				<div class="center-block profile-avatar">
					<img class="img-avatar" v-if="imageDataPreview!=null" :src="imageDataPreview" :alt="modalUser.email">
					<div v-else-if="modalUser.photoURL === null || modalUser.photoURL === ''" class="avatar_hrs_profile avatar-bg">{{ modalUser.display_name | short_name}}</div>
					<img class="img-avatar" v-else :src="modalUser.photoURL" :alt="modalUser.email">
				</div>
			</b-row>
			<b-row>
				<b-col>
					<b-form-file 
						v-on:change="previewImage"
						:placeholder="upload_placeholder"
						drop-placeholder="Povleci sliko..."
						:accept="upload_accept"
						></b-form-file>
						<div>
							<p>Progress: {{uploadValue.toFixed()+"%"}}
							<progress id="progress" :value="uploadValue" max="100" ></progress>  </p>
						</div>
				</b-col>
			</b-row>
		</b-form>
	</b-modal>
</template>
<style>
</style>
<script>
import firebase from 'firebase';
const IMG_PH_TEXT = 'Izberi ali povleci sliko ...';

export default {
	name: 'editUserPictureModal',
	methods: {
		showModal: function (user) {
			this.modalUser.id = user.id;
			this.modalUser.email = user.email;
			this.modalUser.photoURL = user.photoURL;
			this.modalUser.display_name = user.display_name;
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			this.modalErrorMsg = null;
			this.modalIsBusy = true;
			const storageRef = firebase.storage().ref(`${'profiles/' + this.modalUser.email + '/' + Date.now() + '_' + this.imageData.name}`).put(this.imageData);
			storageRef.on('state_changed', (snapshot) => {
				this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			}, (error) => {
				if (error) {
					console.log(error.message);
				}
				this.modalErrorMsg = 'Napaka pri nalaganju slike.';
			},
			() => {
				this.uploadValue = 100;
				storageRef.snapshot.ref.getDownloadURL().then((url) => {
					this.uploadValue = 100;
					let usr = firebase.auth().currentUser;
					// update firebase user photo
					usr.updateProfile({
						photoURL: url
					}).then(() => {
						// update local storage
						let newUser = { ...this.user };
						newUser.photoURL = url;
						this.$store.dispatch('setUser', newUser);
						this.$emit('edit_picture');
						// update modal
						this.clearModal();
						this.modalIsBusy = false;
						this.$refs.modal.hide();
					}).catch(function (error) {
						if (error) {
							console.log(error);
						}
						this.modalErrorMsg = 'Napaka pri spreminjanju slike uporabnika.';
					});
				});
			});
		},
		onCancelModal: function (evt) {
			this.clearModal();
			this.$refs.modal.hide();
		},
		previewImage: function (event) {
			var input;
			if (event instanceof DragEvent) {
				this.imageData = event.dataTransfer.files[0];
				input = event.dataTransfer;
			} else {
				this.imageData = event.target.files[0];
				input = event.target;
			}
			if (input.files && input.files[0]) {
				var reader = new FileReader();
				reader.onload = (e) => {
					this.imageDataPreview = e.target.result;
				}
				reader.readAsDataURL(input.files[0]);
			}
		},
		clear_error_msg: function (event) {
			this.modalErrorMsg = null;
		},
		clearModal: function () {
			this.imageData = null;
			this.imageDataPreview = null;
			this.uploadValue = 0;
			this.modalErrorMsg = null;
			this.modalIsBusy = false;
			this.modalUser.id = 0;
			this.modalUser.email = '';
			this.modalUser.phoroUrl = '';
			this.modalUser.display_name = '';
		}
	},
	data: function () {
		return {
			imageData: null,
			imageDataPreview: null,
			uploadValue: 0,
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Sprememba profilne slike',
			modalOkTitle: 'Shrani',
			modalCancelTitle: 'Prekliči',
			modalUser: {
				id: 0,
				email: '',
				phoroUrl: '',
				display_name: ''
			}
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		upload_accept () {
			return '.jpg';
		},
		upload_placeholder () {
			return IMG_PH_TEXT;
		}
	}
};
</script>
<style>
	.center-block {
		display: block;
		margin-top: 10px;
		margin-bottom: 10px;
		margin-left: auto;
		margin-right: auto;
	}
	.profile-avatar {
		position: relative;
	}
	.profile-avatar .avatar_hrs_profile {
		height: 200px;
		width: 200px;
		line-height: 199px;
		text-align: center;
		font-size: 4em;
		color: #29363d;
	}
	.profile-avatar .img-avatar {
		border-radius: 0;
		height: 200px;
		width: 200px;
	}
	.profile-avatar .actions {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		text-align: center;
	}
	.profil-geslo {
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/EditUserPictureModal.vue